import { connect } from 'react-redux'

import HomePage from 'HomePage/HomePage'

const mapStateToProps = ({ oidc: { user }, google }) => ({
  profile: user && user.profile
})

export default connect(mapStateToProps)(HomePage)



// WEBPACK FOOTER //
// ./src/HomePage/HomePageContainer.js